import { gql, useQuery } from "@apollo/client";
import { LIST_HEADER } from "apollo/queries/ListHeader";
import LetUsKnow from "./LetUsKnow";
import HeroSection from "./HeroSection";
import BecomeAPartner from "./BecomeAPartner";
import HeroBanner from "./HeroBanner";

function PartnerPage() {
  const { data, loading } = useQuery(gql(LIST_HEADER), {
    variables: { filter: { type: "PARTNER" } },
  });

  return (
    <>
      <HeroSection data={data} loading={loading} />
      <BecomeAPartner />
      <LetUsKnow />
      <HeroBanner data={data} loading={loading} />
    </>
  );
}

export default PartnerPage;
